export const getFieldIdFromPlaceholder = ({
  placeholder,
}: {
  placeholder: string;
}): number => {
  const fieldId = placeholder.replace(/\D/g, "");

  return parseInt(fieldId);
};
